export const initialUserInfo = {
  user_id: "",
  customername: "",
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  token: "",
  role: "",
  username: "",
  is_active: 0,
  created_at: "",
};

export interface UserInterface {
  user_id: number;
  customername: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  is_active: number;
  role_name: string;
  created_at: string;
}

export interface IUserState {
  isAuthenticating: boolean;
  hasError: boolean;
  errorMessage: string;
  userInfo: typeof initialUserInfo;
  listUser: UserListInterface[];
  userListFetching: boolean;
  userListFetchError: string;
}

export interface ILoginRequestBody {
  username: string;
  password: string;  
}

export interface IAddUserRequestBody {
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  password: string;
  role_name: string;
  is_active: number;
}

export interface IEditUserRequestBody {
  user_id: number;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone: string;
  role_name: string;
  is_active: number;
  password?: string;
}

export interface IAuth {
  data: {
    role: string;
    token: string;
    id: string;
    email: string;
    firstname: string;
    lastname: string;
  };
  status: string;
}

export interface IAddUser {
  data: {
    id: string;
  };
  status: string;
}

export interface IResetCustomerPassword {
  user_id: string;
}

export interface UserListInterface {
  user_id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  is_active: number;
  role_name: string;
}
